import React, { FC } from "react";

import { AvatarImage } from "@/features/common/components/avatar/Avatar";
import ProfilePicturePlaceholderSrc from "@/features/placeholder/ProfilePicturePlaceholderSrc";
import { useUserBasicInfoQuery } from "@/generated/generated-hooks";

export const AvatarByWalletAccount: FC<{
  walletAccount: string;
  alt?: string;
  height?: string;
  width?: string;
}> = (props) => {
  const { walletAccount, alt, width, height } = props;
  // match the user of the walletAccount from database
  const { data: fetchedUserByWalletAccount } = useUserBasicInfoQuery({
    variables: {
      walletAccount,
    },
    context: { batch: true },
  });

  return (
    <div
      className={`relative border-2 border-white inline-block rounded-full ${
        width ? width : "w-16"
      } ${height ? height : "h-16"} overflow-hidden`}
    >
      <AvatarImage
        src={
          fetchedUserByWalletAccount?.user?.avatar?.url ??
          ProfilePicturePlaceholderSrc
        }
        alt={
          alt
            ? alt
            : `this is the avatar of the owner of wallet account ${walletAccount}`
        }
      />
    </div>
  );
};
